import React from 'react';
import PropTypes from 'prop-types';

const ConfirmDialog = ({
  title,
  message,
  onConfirm,
  onCancel,
  confirmButtonText = '確認',
  cancelButtonText = 'キャンセル'
}) => {
  return (
    <div className="modal-overlay z-50">
      <div className="modal-content max-w-sm">
        <div className="p-6">
          <h2 className="text-lg font-semibold text-primary-700 mb-4">{title}</h2>
          <p className="text-gray-600 mb-6 whitespace-pre-line">{message}</p>
          <div className="flex justify-end gap-3">
            {onCancel && (
              <button
                onClick={onCancel}
                className="btn btn-outline"
              >
                {cancelButtonText}
              </button>
            )}
            <button
              onClick={onConfirm}
              className="btn btn-error"
            >
              {confirmButtonText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ConfirmDialog.propTypes = {
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func, // requiredを削除してnullを許容
  confirmButtonText: PropTypes.string,
  cancelButtonText: PropTypes.string
};

export default ConfirmDialog;